export enum EnumTipoDesconto {
    Promocao = '0 - Promocao', //DESCONTO DE PROMOÇÃO
    Pagamento = '1 - Pagamento', //DESCONTO NA VENDA
    Item = '2 - Item' //DESCONTO NO PRODUTO
}